import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { ReclassificationOptionEntity } from '../../../domain/entities/reclassification-option.entity';

@Injectable({ providedIn: 'root' })
export class GetReclassificationOptionsUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(): Observable<ReclassificationOptionEntity[]> {
    return this._repository.getReclassificationOptions();
  }
}
